/* eslint-disable react/display-name */
import React from 'react';
import BasicResultsList from '../commons/BasicResultsList';
import NoResultsLayout from '../commons/NoResultsLayout';
import SpecificErrorLayout from '../commons/SpecificErrorLayout';
import SearchingLayout from '../commons/SearchingLayout';
import TripsResult from '../commons/TripsResult';

export const components = {
  ErrorContainerLayout: (props) => <SpecificErrorLayout {...props} mobile />,
  SearchingLayout: (props) => <SearchingLayout {...props} mobile />,
  NoResultsLayout: (props) => <NoResultsLayout {...props} mobile />,
  ResultsLayout: (props) => <TripsResult {...props} mobile />
};

export const MobileSearchResults = (props) => (
  <BasicResultsList {...props} components={components} />
);

export default MobileSearchResults;
